import { motion } from 'framer-motion'

import { styled } from 'styled-system/jsx'

const PageStack = styled(motion.div, {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    paddingY: '24px',
  },
})

const Header = styled('header', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
})

const PageTitle = styled('h1', {
  base: {
    fontFamily: 'display',
    fontSize: '28px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
    letterSpacing: '-0.5px',
  },
})

const PageSubtitle = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '15px',
    color: 'quickpass.inkSoft',
    margin: '0',
    lineHeight: '1.55',
    maxWidth: '640px',
  },
})

const PrivacyBanner = styled('div', {
  base: {
    background:
      'linear-gradient(135deg, rgba(46, 184, 137, 0.12) 0%, rgba(46, 184, 137, 0.04) 100%)',
    border: '1.5px solid rgba(46, 184, 137, 0.25)',
    borderRadius: 'lg',
    padding: '14px 18px',
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.ink',
    lineHeight: '1.55',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
})

const PrivacyGlyph = styled('span', {
  base: {
    fontSize: '18px',
  },
})

const Grid = styled('div', {
  base: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
    gap: '16px',
  },
})

const EmptyCard = styled('section', {
  base: {
    backgroundColor: '#FFFFFF',
    border: '1.5px dashed',
    borderColor: '#D8D2EE',
    borderRadius: 'lg',
    padding: '32px 24px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
  },
})

const EmptyEmoji = styled('span', {
  base: {
    fontSize: '38px',
  },
})

const EmptyTitle = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: '18px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
  },
})

const EmptyBody = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    margin: '0',
    maxWidth: '420px',
    lineHeight: '1.55',
  },
})

const ErrorBanner = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.warmth',
    fontWeight: '600',
    backgroundColor: 'rgba(214, 66, 66, 0.08)',
    border: '1.5px solid rgba(214, 66, 66, 0.25)',
    borderRadius: 'md',
    padding: '12px 14px',
  },
})

const StatusText = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    fontStyle: 'italic',
    textAlign: 'center',
    paddingY: '32px',
  },
})

export {
  PageStack,
  Header,
  PageTitle,
  PageSubtitle,
  PrivacyBanner,
  PrivacyGlyph,
  Grid,
  EmptyCard,
  EmptyEmoji,
  EmptyTitle,
  EmptyBody,
  ErrorBanner,
  StatusText,
}
